export default "__VITE_ASSET__PndzfNVa__"